import { resolveBrowserApiBaseUrl } from '@/lib/campaign-custom-domain'

/**
 * Typed environment variables. Only `VITE_*` values are exposed to the frontend build.
 */

function normalizeApiBaseUrl(value: string | undefined): string {
  const trimmed = (value ?? '').trim().replace(/\/+$/, '')
  if (trimmed.toLowerCase().endsWith('/api')) {
    return trimmed.slice(0, -4)
  }

  return trimmed
}

function widgetAssetVersion(): string {
  const fromEnv = (import.meta.env.VITE_WIDGET_ASSET_VERSION ?? '').trim()
  // Include the shipped revision even if deployment still pins an older env value.
  // Otherwise a four-hour browser/CDN cache can keep the previous checkout flow.
  return [fromEnv, '20261001-global-donor-1', '20261021-combo-cart-1', '20261022-compact-combos-1'].filter(Boolean).join('-')
}

function landingEmbedAssetVersion(): string {
  const fromEnv = (import.meta.env.VITE_LANDING_EMBED_ASSET_VERSION ?? '').trim()
  if (fromEnv) return fromEnv
  return '9'
}

const configuredApiBaseUrl = normalizeApiBaseUrl(import.meta.env.VITE_API_BASE_URL)
const publicAppUrl = (import.meta.env.VITE_PUBLIC_APP_URL ?? '')
  .trim()
  .replace(/\/+$/, '')

function currentApiBaseUrl(): string {
  if (typeof window === 'undefined') {
    return configuredApiBaseUrl
  }

  return resolveBrowserApiBaseUrl(
    window.location.hostname,
    configuredApiBaseUrl,
    publicAppUrl
  )
}

export const env = {
  get apiBaseUrl(): string {
    return currentApiBaseUrl()
  },
  configuredApiBaseUrl,
  publicAppUrl,
  appTitle: import.meta.env.VITE_APP_TITLE ?? 'Sistema de Sorteios',
  widgetAssetVersion: widgetAssetVersion(),
  landingEmbedAssetVersion: landingEmbedAssetVersion(),
}
